module.exports = __webpack_public_path__ + "img/assignments.04ab569f.png";